<!-- Confirm Email Component - Modern Bootstrap 5.3.7 -->
<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
      
      <!-- Confirmation Card -->
      <div class="card shadow-lg border-0 confirm-email-card">
        <div class="card-body p-4 p-md-5">
          
          <!-- Header -->
          <div class="text-center mb-4">
            <div class="confirm-icon mb-3">
              <i class="fa fa-check-circle fa-4x text-success"></i>
            </div>
            <h2 class="card-title fw-bold text-dark mb-3">
              {{ 'CONFIRM_EMAIL.THANK_YOU' | translate }} {{ this.email }}
            </h2>
          </div>
          
          <!-- Content -->
          <div class="text-center">
            <div class="alert alert-success border-0 bg-light-success mb-4">
              <i class="fa fa-envelope-open me-2"></i>
              <p class="mb-0 lead">
                {{ 'CONFIRM_EMAIL.REGISTRATION_CONFIRMED' | translate }}
              </p>
            </div>
            
            <!-- Action Buttons -->
            <div class="d-grid gap-2">
              <a 
                [routerLink]="['/login']"
                class="btn btn-primary btn-lg fw-semibold"
                [attr.aria-label]="'CONFIRM_EMAIL.LOGIN_NOW' | translate">
                <i class="fa fa-sign-in me-2"></i>
                {{ 'CONFIRM_EMAIL.LOGIN_NOW' | translate }}
              </a>
              
              <a 
                [routerLink]="['/']"
                class="btn btn-outline-secondary"
                [attr.aria-label]="'CONFIRM_EMAIL.BACK_HOME' | translate">
                <i class="fa fa-home me-2"></i>
                {{ 'CONFIRM_EMAIL.BACK_HOME' | translate }}
              </a>
            </div>
          </div>
          
          <!-- Additional Info -->
          <hr class="my-4">
          <div class="text-center">
            <p class="text-muted small mb-0">
              <i class="fa fa-info-circle me-1"></i>
              {{ 'CONFIRM_EMAIL.NEXT_STEPS' | translate }}
            </p>
          </div>
          
        </div>
      </div>
      
    </div>
  </div>
</div>
